<template>
    <el-container>
        <el-header>
            <div class="header-left">
                <router-link to="/"><img class="logo" src="../../assets/images/logo.png"></router-link>
            </div>
            <div class="header-right">
                <span class="item"><router-link to="/login"><i class="iconfont iconyonghu"></i> 登入</router-link></span>
            </div>
        </el-header>
        <el-main>
            <el-card class="box-card">
                <div class="title">账号注册</div>
                <el-form :model="codeForm" :rules="rules" ref="codeForm">
                    <el-form-item prop="uname">
                        <el-input placeholder="账号，请输入5-12位数字、字母" v-model="codeForm.uname" clearable prefix-icon="el-icon-mobile-phone" maxlength="15"></el-input>
                    </el-form-item>
                  <el-form-item prop="pass">
                    <el-input placeholder="设置密码" v-model="codeForm.upass" clearable prefix-icon="el-icon-mobile-phone" maxlength="11"></el-input>
                  </el-form-item>
                  <el-form-item prop="pass2">
                    <el-input placeholder="再次确认密码" v-model="codeForm.upass2" clearable prefix-icon="el-icon-mobile-phone" maxlength="11"></el-input>
                  </el-form-item>

                    <el-form-item prop="agreement">
                        <el-checkbox v-model="codeForm.agreement">阅读并接受</el-checkbox>
                        <span class="agreement" @click="agreement">《用户服务协议》</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('codeForm')" :loading="btnLoading" class="login_btn">{{loginBtnTxt}}</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </el-main>
        <el-footer><div class="copyright">Copyright &copy; 2018-2020  版权所有</div></el-footer>
        <agreement ref="agreement"></agreement>

    </el-container>
</template>

<script>
    import agreement from "../../components/agreement";
    import apiConfig from '../../api/api.config';

    export default {
        name: "Reg",
        data() {
            let uname = (rule, value, callback) => {
                if (value.match(/^[0-9_a-z]{5,12}/) == null) {
                    callback(new Error('请输入5-12位数字、字母'));
                } else {
                    callback();
                }
            };
          let upass = (rule, value, callback) => {
            if (value === '') {
              callback(new Error(''));
            } else if (value.match(/^[0-9_a-z]{5,12}/) == null) {
              callback(new Error('请输入5-12位密码'));
            } else {
              callback();
            }
          };



            let agreement = (rule, value, callback) => {
                if (value){
                    callback();
                } else {
                    callback(new Error('请阅读并勾选用户协议'));
                }
            };
            return {
                activeName: '1',
                time: 0,
                disabled: false,
                btnTxt: "获取验证码",
                btnLoading: false,
                loginBtnTxt: "注册",
                uniqueID: "",
                captcha: "",
                captchaUrl: "",
                captchaStr: "",
                captchaDialog: false,
                codeForm: {
                    uname: '',
                    upass: '',
                    upass2: '',
                    agreement: true,
                },
                rules: {
                    uname: [
                        { validator: uname, trigger: 'blur' }
                    ],
                    upass: [
                        { validator: upass, trigger: 'blur' }
                    ],

                    agreement: [
                        { validator: agreement, trigger: 'blur' }
                    ],
                },
            }
        },
        mounted() {
            const token = this.$store.state.token;
            const codeTime = this.$cookies.get('codeTime');
            const capStr = this.$cookies.get('captchaStr');

            if (token !== undefined && token !== null && token !== ''){
                this.$router.push('/tabs/index');
            }
            if (capStr !== undefined && capStr !== null && capStr !== ''){
                this.captchaStr = capStr;
            }
            if (codeTime > 10){
                console.log(codeTime);
                this.time = codeTime;
                this.timer();
            }else {
                this.$cookies.remove('codeTime');
            }
        },
        methods:{
            submitForm(formName) {
              if(this.codeForm.upass2!=this.codeForm.upass){
                this.$message.error("两次密码不一致！");
                return false;
              }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.reg();
                    }
                });
            },
            async reg() {
                console.log('codeLogin');
                this.btnLoading = true;
                this.loginBtnTxt = "注册中...";
                let postData = {
                  uname: this.codeForm.uname,
                    upass: this.codeForm.upass,
                    check: this.codeForm.agreement,
                };

                const {ret,data} = await this.$api.reg(postData);
                this.btnLoading = false;
                this.loginBtnTxt = "注册";
                if (ret === 1000){
                    this.$storeLocal.set('token',data.token);
                    this.$storeLocal.set('userInfo',data.user_info);
                    this.$store.state.token = data.token;
                    this.$cookies.remove('codeTime');
                    await this.$router.push('/tabs/index');
                }
            },

            agreement() {
                this.$refs.agreement.show();
            },
        },
        components: {
            agreement
        },
    }
</script>

<style scoped>
    #qrCode{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        border: 1px solid #d7dae2;
    }
    .el-container{
        width: 1200px;
        margin: 0 auto;
    }
    .header-left{
        display: inline-block;
        width: 130px;
        height: 48px;
        padding: 6px 0;
        vertical-align: top;
    }
    .header-left .logo{
        width: 130px;
    }
    .header-right{
        display: inline-block;
        width: 1000px;
        height: 22px;
        padding: 19px 0;
        margin-left: 30px;
        vertical-align: top;
        text-align: right;
    }
    .header-right .item{
        display: inline-block;
        height: 22px;
        text-align: center;
    }
    .header-right .item a{
        color: #666666;
    }
    .vcode{
        width: 200px;
        margin-right: 20px;
    }
    .sendBtn{
        width: 140px;
    }
    .login_btn{
        width: 100%;
    }
    .box-card{
        width: 400px;
        margin: 100px auto;
    }
    .box-card .title{
        font-size: 22px;
        color: #666;
        text-align: center;
        overflow: hidden;
        margin-bottom: 20px;
    }
    .countdown{
        width: 100%;
        height: 30px;
        font-size: 14px;
        text-align: center;
    }
    .image-slot{
        width: 200px;
        height: 200px;
        text-align: center;
        line-height: 200px;
        background-color: rgba(0,0,0,0.1);
    }
    .image-slot i{
        color: #808080;
        font-size: 50px;
    }
    .agreement{
        color: #409EFF;
        font-weight: 500;
        cursor: pointer;
    }
    .copyright{
        width: 100%;
        color: #666666;
        text-align: center;
    }
    .captcha-lab{
        display: inline-block;
        width: 60px;
        height: 40px;
        line-height: 40px;
        vertical-align: top;
    }
    .captcha-inp{
        display: inline-block;
        width: 170px;
        vertical-align: top;
    }
    .captcha-img{
        display: inline-block;
        width: 110px;
        height: 36px;
        padding: 2px 0;
        margin-left: 10px;
        vertical-align: top;
    }
</style>

